export default __webpack_public_path__ + "static/media/ChevronRightFilled.8f3b17db.svg";